// extracted by mini-css-extract-plugin
export default {"container":"nav_user-module__container--299J3","picture":"nav_user-module__picture--CuGLb","username":"nav_user-module__username--R_caH"};